import { isLocal } from '../../localId/localId';
import {
  ADD_LOCAL_EQUIPMENT_TIMESHEET, API_CREATE_EQUIPMENT_TIMESHEET,
  API_REMOVE_EQUIPMENT_TIMESHEET, API_UPDATE_EQUIPMENT_TIMESHEET, dirtyTimesheets,
  REMOVE_LOCAL_EQUIPMENT_TIMESHEET,
  SAVE_EQUIPMENT_TIMESHEET,
} from './equipmentTimesheets.reducer';

export const save = resource => ({ type: SAVE_EQUIPMENT_TIMESHEET, resource });
export const add = workOrderId => ({ type: ADD_LOCAL_EQUIPMENT_TIMESHEET, workOrderId });
export const remove = id => ((isLocal(id))
  ? ({ type: REMOVE_LOCAL_EQUIPMENT_TIMESHEET, id })
  : ({ resourceAction: API_REMOVE_EQUIPMENT_TIMESHEET, id }));

export const apiSaveDirty = () =>
  (dispatch, getState) =>
    Promise.all(dirtyTimesheets(getState()).map(resource =>
      ((isLocal(resource.id))
        ? dispatch({ resourceAction: API_CREATE_EQUIPMENT_TIMESHEET, resource })
        : dispatch({ resourceAction: API_UPDATE_EQUIPMENT_TIMESHEET, resource }))));



// WEBPACK FOOTER //
// ./src/reducers/workOrder/equipmentTimesheets/equipmentTimesheets.actions.js